import { useLocation } from 'react-router-dom'

const useActive = () => {

    const { pathname } = useLocation();

    const normalizePath = (value = '') => {
        if (!value) return '/';
        if (value === '/') return '/';
        return value.replace(/\/+$/, '');
    };

    const isActive = (path = '', type = 'normal') => {
        const currentPath = normalizePath(pathname);
        const targetPath = normalizePath(path);

        if (type === 'normal') {
            // Keep root exact; for others allow nested URLs to stay highlighted.
            if (targetPath === '/') {
                return currentPath === '/';
            }

            return (
                currentPath === targetPath ||
                currentPath.startsWith(`${targetPath}/`)
            );
        }

        return currentPath.includes(targetPath)
    }

    return { isActive }
}

export { useActive }
